export interface GossipTestimonial {
  name: string;
  role: string;
  quote: string;
  avatar: string;
}

export const gossipTestimonials: GossipTestimonial[] = [
  {
    name: "陆知夏",
    role: "每天通勤刷一遍",
    quote:
      "以前追一个瓜要在好几个平台之间来回翻，现在直接看事件串，从上读到下，谁先回应、谁后补充一目了然，通勤路上刚好读完一条。",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20editorial%20portrait%20illustration%20of%20a%20young%20woman%20with%20short%20hair%2C%20coral%20and%20green%20flat%20color%20blocks%20on%20a%20cream%20background%2C%20minimal%20magazine%20style%2C%20gentle%20lighting&width=200&height=200&seq=gua-avatar-01&orientation=squarish",
  },
  {
    name: "顾言",
    role: "影视区内容爱好者",
    quote:
      "最喜欢的是它不替你下结论。换角那件事，页面把路透、回应和补充说明都列出来，还标了信源范围，看完心里自己有数。",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20editorial%20portrait%20illustration%20of%20a%20young%20man%20wearing%20glasses%2C%20coral%20and%20mustard%20flat%20color%20blocks%20on%20a%20cream%20background%2C%20minimal%20magazine%20style%2C%20soft%20light&width=200&height=200&seq=gua-avatar-02&orientation=squarish",
  },
  {
    name: "苏晚",
    role: "学生党",
    quote:
      "合集整理得很舒服，同一主题下面的事件按顺序排好，不会重复看同一段。周末两小时能把一周的热点扫完，效率高。",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20editorial%20portrait%20illustration%20of%20a%20young%20woman%20with%20long%20hair%2C%20green%20and%20coral%20flat%20color%20blocks%20on%20a%20cream%20background%2C%20minimal%20magazine%20style%2C%20gentle%20light&width=200&height=200&seq=gua-avatar-03&orientation=squarish",
  },
  {
    name: "郑屿",
    role: "品牌市场从业者",
    quote:
      "作为从业者，我反而会看它的公关复盘。品牌物料下架那一条，把十二小时的空窗拆成了几个节点，对做传播的人来说挺有参考价值。",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20editorial%20portrait%20illustration%20of%20a%20man%20with%20short%20beard%2C%20mustard%20and%20green%20flat%20color%20blocks%20on%20a%20cream%20background%2C%20minimal%20magazine%20style&width=200&height=200&seq=gua-avatar-04&orientation=squarish",
  },
  {
    name: "何一宁",
    role: "长期读者",
    quote:
      "更新标记很实在，同一个事件会告诉你什么时间补了新内容。我一般收藏几个在追的，过两天回来看有没有新节点，很省事。",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20editorial%20portrait%20illustration%20of%20a%20young%20woman%20with%20bangs%2C%20coral%20green%20and%20gold%20flat%20color%20blocks%20on%20a%20cream%20background%2C%20minimal%20magazine%20style&width=200&height=200&seq=gua-avatar-05&orientation=squarish",
  },
];